import styled from '@emotion/styled'

import { colors, vars } from '@/styles/theme'
import { mediaUp } from '@/styles/media'

export const Container = styled.section`
  position: relative;
  background-color: ${colors.paleGrey};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-width: 288px;
  min-height: 276px;
  border-radius: 16px;
  margin: 64px 16px 16px 16px;
  z-index: 1;

  ${mediaUp('md')} {
    margin: 64px 16px;
  }
`

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  padding: 24px 16px 0 16px;
`

export const Wrapper = styled.div<{ noPadding: boolean }>`
  padding-top: ${({ noPadding }) => (noPadding ? '0' : '10px')};

  ${mediaUp('md')} {
    padding-top: 20px;
    padding-bottom: 60px;
  }

  ${mediaUp('lg')} {
    padding-top: 20px;
    padding-bottom: 80px;
    margin-top: ${vars.headerHeight};
  }
`
